import styled from "styled-components";
import { motion } from "framer-motion";

export const Section = styled.section`
  align-items: flex-start;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 0px;
  height: min-content;
  justify-content: flex-start;
  overflow: visible;
  padding: 0;
  position: relative;
  width: 100%;
  z-index: 2;
`;

export const StickyContainer = styled.div`
  align-items: flex-start;
  display: flex;
  flex: none;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 0px;
  height: min-content;
  justify-content: flex-start;
  overflow: hidden;
  padding: 0;
  position: sticky;
  top: 90px;
  width: 100%;
  z-index: 1;

  @media (max-width: 768px) {
    top: 0;
    position: static;
  }
`;

export const ContentWrapper = styled.div`
  align-items: center;
  background-color: #000;
  display: flex;
  flex: none;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 0px;
  height: min-content;
  justify-content: center;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ContentContainer = styled.div`
  flex: none;
  height: 100vh;
  position: relative;
  width: calc(100% / 4);
  z-index: 5;
  will-change: transform;
  transform-style: preserve-3d;
  background-color: ${(props) => props.bgColor || "rgb(247, 96, 0)"};
  transition: background-color 0.3s ease;

  @media (max-width: 768px) {
    height: auto;
    width: 100%;
  }
`;

export const FeatureCard = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 40px;
  justify-content: center;
  overflow: hidden;
  padding: 200px 40px;
  position: relative;
  border-left: 4px solid rgb(247, 96, 0);
  height: 100%;
  width: 100%;

  @media (max-width: 1440px) {
    padding: 160px 32px;
    gap: 32px;
  }

  @media (max-width: 1024px) {
    padding: 120px 24px;
    gap: 24px;
  }

  @media (max-width: 768px) {
    padding: 40px 20px;
    gap: 10px;
  }
`;

export const FeatureIcon = styled.div`
  flex: none;
  height: 40px;
  position: absolute;
  right: 20px;
  top: 20px;
  width: 40px;
  z-index: 1;

  @media (max-width: 768px) {
    height: 32px;
    width: 32px;
    right: 8px;
    top: 8px;
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-position: center center;
    object-fit: contain;
  }
`;

export const FeatureContent = styled.div`
  align-items: center;
  display: flex;
  flex: 1 0 0px;
  flex-direction: column;
  flex-wrap: nowrap;
  gap: 20px;
  height: 1px;
  justify-content: center;
  overflow: hidden;
  padding: 0;
  width: 100%;

  @media (max-width: 768px) {
    flex: none;
    height: auto;
  }
`;

export const FeatureTitle = styled.h2`
  flex: none;
  height: auto;
  white-space: pre-wrap;
  width: 100%;
  word-break: break-word;
  word-wrap: break-word;
  flex-shrink: 0;
  will-change: transform;
  transform: perspective(1200px);
  font-family: "Inter Display", sans-serif;
  font-size: 50px;
  font-weight: 400;
  letter-spacing: -0.03em;
  line-height: 1.2;
  color: rgb(204, 204, 204);
  display: inline-block;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  background-image: linear-gradient(
    24deg,
    rgb(255, 255, 247) 0%,
    rgba(255, 255, 247, 0.34) 100%
  );

  @media (max-width: 1024px) {
    font-size: 40px;
  }

  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

export const FeatureDescription = styled.p`
  flex: none;
  height: auto;
  white-space: pre-wrap;
  width: 100%;
  word-break: break-word;
  word-wrap: break-word;
  flex-shrink: 0;
  text-shadow: rgba(155, 221, 237, 0) 0px 0px 8px;
  transform: none;
  font-family: "Inter Display", sans-serif;
  font-size: 26px;
  font-weight: 500;
  line-height: 1.4em;
  text-align: left;
  color: rgb(221, 214, 197);

  @media (max-width: 1024px) {
    font-size: 22px;
  }

  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

export const FeatureImageContainer = styled.div`
  flex: 1 0 0px;
  height: 1px;
  width: 100%;

  @media (max-width: 768px) {
    flex: none;
    height: 50%;
    aspect-ratio: 2 / 1;
  }
`;

export const FeatureImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  object-position: center center;
  object-fit: cover;
`;

export const ScrollArea = styled.div`
  align-items: flex-start;
  display: flex;
  flex: none;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 0px;
  height: min-content;
  justify-content: flex-start;
  min-height: 640px;
  overflow: hidden;
  padding: 0;
  position: relative;
  width: 100%;
  z-index: 2;

  @media (max-width: 768px) {
   min-height: 0;
  }
`;
